import ReactApexChart from "react-apexcharts";

import { numberToBRL } from "~/modules/sales/services";

import type { LicenseExtensionPopularityData } from "./types";

type Props = {
	data: LicenseExtensionPopularityData[];
};

export const LicenseComparisonChart: React.FC<Props> = ({ data }) => {
	return (
		<div className="bg-white rounded-xl shadow-md p-6 mb-6 overflow-hidden">
			<h2 className="text-lg font-semibold text-gray-700 mb-6">
				Comparativo de Pacotes
			</h2>
			<div className="overflow-x-auto">
				<ReactApexChart
					type="bar"
					height={350}
					width="100%"
					options={{
						chart: {
							type: "bar",
							stacked: false,
							toolbar: { show: false },
						},
						plotOptions: {
							bar: {
								horizontal: false,
								columnWidth: "55%",
								borderRadius: 4,
							},
						},
						dataLabels: { enabled: false },
						stroke: { show: true, width: 2, colors: ["transparent"] },
						xaxis: {
							categories: data.map((d) => d.name),
						},
						yaxis: { title: { text: "Quantidade / Valor" } },
						fill: { opacity: 1 },
						tooltip: {
							y: {
								formatter: (val, { seriesIndex }) =>
									seriesIndex === 1 ? numberToBRL(val / 100) : val + " compras",
							},
						},
						legend: { position: "top", horizontalAlign: "left" },
						colors: ["#9333ea", "#10b981"],
					}}
					series={[
						{
							name: "Total de Compras",
							data: data.map((d) => d.totalPurchases),
						},
						{
							name: "Receita Total (centavos)",
							data: data.map((d) => d.totalRevenue),
						},
					]}
				/>
			</div>
		</div>
	);
};
